import { pxToRem } from "@ui/lib/utils";

export const PILL_SIZES: Record<
  string,
  { heightClass: string; widthClass?: string; padding: number; textClass: string }
> = {
  sm: { heightClass: "tw-h-10", padding: 16, textClass: "tw-type-base" },
  "sm-pill": {
    heightClass: "tw-h-10",
    widthClass: "tw-w-[calc(2.625rem+var(--padding-offset))]",
    padding: 16,
    textClass: "tw-type-base",
  },
  "sm-responsive": { heightClass: "tw-h-10", padding: 16, textClass: "tw-text-xs md:tw-type-base" },
  md: { heightClass: "tw-h-11", padding: 18, textClass: "tw-type-base" },
  lg: { heightClass: "tw-h-12", padding: 18, textClass: "tw-type-base" },
} as const;

export type PillSize = keyof typeof PILL_SIZES;
export type PillSurface = "white" | "cream" | "paper" | "dark";
export type PillInactiveTextColor = "default" | "white";

export const PILL_RING_CLASS = "tw-ring-0.5 tw-ring-inset tw-ring-black/7.5";

export const PILL_COLORS = {
  active: "#000000",
  inactive: { default: "#57534e", white: "#ffffff" } satisfies Record<PillInactiveTextColor, string>,
  selectedBg: "#ffffffff",
  transparentBg: "#fafaf900",
  hoverBg: { white: "#fafaf9ff", paper: "#fafaf9ff", cream: "#eeecebff", dark: "rgba(0,0,0,0.16)" } satisfies Record<
    PillSurface,
    string
  >,
  selectedShadow: "0 0 1px rgb(0 0 0 / 0.4), 0 4px 4px rgb(0 0 0 / 0.04)",
  noShadow: "0 0 1px rgb(0 0 0 / 0), 0 4px 4px rgb(0 0 0 / 0)",
} as const;

export function getPillHoverInset(showRing: boolean) {
  return showRing ? 3 : 2;
}

export function getPillItemPadding(padding: number, isFirst: boolean, isLast: boolean) {
  return {
    paddingLeft: pxToRem(isFirst ? padding : padding + 1),
    paddingRight: pxToRem(isLast ? padding : padding + 1),
    "--padding-offset": isFirst && isLast ? pxToRem(-2) : isFirst || isLast ? pxToRem(-1) : pxToRem(0),
  };
}
